import axios from "axios";

export default function GetImgName(setImages: any, anno: number) {

    axios.get(`/gallery/?anno=${anno}`)
        .then(function (response) {
            response.data.forEach((e: any) => {
                setImages((oldArray: any) => [...oldArray, {
                    src: `/gallery/images/${anno}/${e.name}`,
                    info: `${e.info}`,
                }]);
            })
        }).catch(function (error: any) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        })
};

